import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";
import { parseSort } from "../utils/gridSorting";
import { parseFilters } from "../utils/gridSorting";

export const USER_ENDPOINTS = {
  list: `${BASE_URL}api/users/`,
  register: `${BASE_URL}auth/register`,
  admin_create: `${BASE_URL}admin/create-user`,
  me: `${BASE_URL}users/me`,
  detail: (id) => `${BASE_URL}users/${id}`,
  roles: `${BASE_URL}api/roles/`,
};

class Users {
  async getActiveUserInfo() {
    const { data } = await request({
      url: USER_ENDPOINTS.me,
    });
    return data;
  }

  async getUsersList(params) {
    console.log(params);
    const { page, per_page, filterModel, sortModel } = params || {};

    const query = {
      page: page || 1,
      per_page: per_page || 20,

      // Les filtres formatés (ex: search_email="toto")
      ...parseFilters(filterModel),
    };

    const sort = parseSort(sortModel);
    if (sort) {
      // REGLE 2 : On utilise la clé "order_by"
      query.order_by = sort;
    }

    const data = await request({
      url: USER_ENDPOINTS.list,
      method: "GET",
      query: query,
    });

    return data;
  }

  async getUser(id) {
    const { data } = await request({
      url: USER_ENDPOINTS.detail(id),
    });
    return data;
  }

  async getUser(id) {
    const { data } = await request({
      url: USER_ENDPOINTS.detail(id),
    });
    return data;
  }

  async registerUser(userData) {
    const { data, res } = await request({
      url: USER_ENDPOINTS.register,
      method: "POST",
      body: userData,
    });
    return { data, res };
  }

  async createUser(userData) {
    const { data } = await request({
      url: USER_ENDPOINTS.admin_create,
      method: "POST",
      body: userData,
    });
    return data;
  }

  async editUser(id, userData) {
    const { data } = await request({
      url: USER_ENDPOINTS.detail(id),
      method: "PATCH",
      body: userData,
    });
    return data;
  }

  async deleteUser(id) {
    return await request({
      url: USER_ENDPOINTS.detail(id),
      method: "DELETE",
    });
  }

  async getRoles() {
    const { data } = await request({
      url: USER_ENDPOINTS.roles,
    });
    return data;
  }
}

export const UsersService = new Users();
